<template lang="pug">
  .centered
    p.warning(id="ChangePassword-wrongLinkWarning" v-if='!$route.params.email && !$route.params.token')
      span {{ $t('Wrong link or link expired.') }}
    el-form.form(id="ChangePassword-form" v-if='$route.params.email && $route.params.token')
      el-form-item(id="ChangePassword-header")
        h3 {{ $t('Password change') }}
        p.warning {{ $t('Requirements: between 5 to 15 characters, contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character') }}
      el-form-item(id="ChangePassword-formPassword" :label="$t('Enter password')")
        el-input(id="ChangePassword-formPasswordInput" v-model='password1', type='password', @input='responseError = null')
        p.warning(id="ChangePassword-invalidPasswordWarning" v-if='!passwordValid && password1.length > 0') {{ $t('Password is NOT valid') }}
        p.success(id="ChangePassword-validPasswordSuccess" v-if='passwordValid && password1.length > 0') {{ $t('Password is valid') }}
        p.success(v-if='password1.length === 0') &nbsp;
      el-form-item(id="ChangePassword-formConfirmPassword" :label="$t('Confirm password')")
        el-input(id="ChangePassword-formConfirmPasswordInput" v-model='password2', type='password', @input='comparePasswords')
      el-form-item(id="ChangePassword-formSubmit")
        el-button.float-right(id="ChangePassword-formSubmitButton" type='success', size='mini', @click='changePassword', :disabled='passwordsNotEqual')
          span {{ $t('Save new password and log-in')}}
      el-form-item.danger(id="ChangePassword-formResponseError" v-if='responseError')
        p {{ $t(responseError.replace(/_/g, ' ')) }}
      el-form-item(id="ChangePassword-passwordRequirementsMessage" v-if='responseErrorPasswordMessage')
          span.danger {{ $t(responseErrorPasswordMessage) }}
          br
          span.warning {{ $t('Password has to meet following requirements:') }}
          ul.warning
            li
              p {{ $t('at least 8 characters in length,') }}
            li
              p {{ $t('contain at least one upper-case character,') }}
            li
              p {{ $t('contain at least one lower-case character,') }}
            li
              p {{ $t('contain at least one digit,') }}
            li
              p {{ $t('contain at least one special character.') }}
</template>
<script>
import Vue from 'vue'
export default {
  components: {
  },
  data () {
    return {
      errors: {},
      password1: '',
      password2: '',
      responseError: null,
      passwordValid: false,
      passwordsNotEqual: true,
      responseErrorPasswordMessage: false
    }
  },
  methods: {
    async changePassword () {
      this.responseError = undefined
      try {
        await Vue.axios.post('user/changePassword', {
          email: this.$route.params.email,
          token: this.$route.params.token,
          password: this.password1
        }, { disableResponseInterceptors: true })
        this.$router.push({ path: '/' })
      } catch (error) {
        if (error.response.data.error && error.response.data.error.startsWith('Password')) {
          this.responseErrorPasswordMessage = error.response.data.message
        } else {
          this.responseError = error.response.data
        }
      }
    },
    comparePasswords () {
      if (this.password1 === this.password2) {
        this.passwordsNotEqual = false
        return
      }
      this.passwordsNotEqual = true
    }
  },
  computed: {
    users () {
      return true
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.centered {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.form {
  border: 0px solid red;
  width: 500px;
}
.warning {
  color: $--color-warning;
}
p.warning, p.success {
  line-height: 18px;
}
.success {
  color: $--color-success;
}

</style>



// WEBPACK FOOTER //
// src/components/User/ChangePassword.vue